import { isSupported } from 'firebase/messaging';

// Services
import { FirebaseService } from '@services/firebase.service';

// Types
import { TArrowFunction } from '../types/global.types';

export function initializeFirebase(
  firebaseService: FirebaseService,
): TArrowFunction<Promise<boolean>> {
  return () =>
    // eslint-disable-next-line no-async-promise-executor
    new Promise(async (resolve, _) => {
      const supported = await isSupported();

      if (supported && Notification.permission === 'granted') {
        firebaseService.requestPermission();
      }

      // Resolve the promise indicating successful initialization
      resolve(true);
    });
}
